import api from '@/api/Api'

export const state = {
  form: {
    model: undefined,
    image1: undefined,
    image2: undefined,
    name: undefined
  }
}

export const getters = {
  detectionForm (state) {
    return state.form
  }
}

export const mutations = {
  SET_DETECTION_MODEL (state, newValue) {
    state.form.model = newValue
  },
  SET_DETECTION_IMAGE1 (state, newValue) {
    state.form.image1 = newValue
  },
  SET_DETECTION_IMAGE2 (state, newValue) {
    state.form.image2 = newValue
  },
  SET_DETECTION_NAME (state, newValue) {
    state.form.name = newValue
  }
}
export const actions = {
  setDetectionModel ({commit, state}, model) {
    commit('SET_DETECTION_MODEL', model)
  },
  checkBalanceToken ({ commit, state, rootState }, form) {
    const payload = {
      image_id: form.form_data.image,
      file_name: form.form_data.name,
      model_id: form.form_data.model,
      task_name: form.form_data.name,
      env: form.form_data.env
    }
    return api.checkBalanceTokenPredict(form.wks_id, payload).then((response) => {
      return response
    })
  },
  runPrediction ({ commit, state, rootState }, form) {
    return api.prediction(form.wks_id, form.form_data).then((response) => {
      return response
    })
  },
  runCommunityPrediction ({ commit, state, rootState }, form) {
    return api.communityPrediction(form.wks_id, form.form_data).then((response) => {
      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/detection.js